import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addSurveyWithQuestions, UseAddSurveyWithQuestionsProps } from ".";
import { DEFAULT_CRM_SYSTEM } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";

export function useAddSurveyWithQuestions({crm_system = DEFAULT_CRM_SYSTEM}: UseAddSurveyWithQuestionsProps) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['survey','question'],
        mutationFn: addSurveyWithQuestions({crm_system}),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["survey"], exact: false});
        }
    })
}
